import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.checkIn.DOC}
  query CheckIn($tenantId: ID!, $zoneId: ID!, $mood: String) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        checkIn(mood: $mood) {
          ...FragmentCheckIn
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.CheckInQuery,
  ents.core.summit.CheckIn | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select('checkIn', fragments.checkIn.TRANSFORMER),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.CheckInQuery,
  ents.core.summit.CheckIn | undefined,
  graphql.schema.CheckInQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
